const NAMES = {
  APP: 'ACT Gateway',
  COMPANY: 'ACT Education Corp.',
  TOKEN: 'token',
};

export default NAMES;
